module.exports = __webpack_public_path__ + "static/img/yizhangtu_03.d3b23c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yizhangtu_03.png
// module id = a0wG
// module chunks = 1